import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import sidom from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_STRAPI_URL}/api/auth/local`,
        {
          identifier,
          password,
        }
      );

      localStorage.setItem("jwt", res.data.jwt);
      // Guardamos el nombre de usuario para mostrar un saludo personalizado
      localStorage.setItem(
        "username",
        res.data.user.nombre || res.data.user.username
      );
      navigate("/dashboard");
    } catch (err) {
      setError("Usuario o contraseña incorrectos");
    }
  };

  return (
    <>
      <main className="flex items-center justify-center min-h-screen bg-sidom-blue">
        <section className="bg-gradient-to-t from-sidom-blue via-sidom-blue to-sidom-orange border-4 border-sidom-orange rounded-2xl hover:border-sidom-gray transition-all duration-200 shadow-lg">
          <div className="mx-auto flex items-center space-y-4 py-12 px-8 font-semibold text-gray-500 flex-col w-80">
            <button
              onClick={() => (window.location.href = "/")}
              className="self-start mb-4 flex items-center gap-2 text-white hover:text-sidom-orange transition-colors"
              title="Ir al Home"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 12l9-9 9 9M4.5 10.5V21h15V10.5"
                />
              </svg>
              Home
            </button>
            <div className="flex  items-center mb-8  text-right">
              <img src={sidom} className="w-[300px] " alt="Logo Sidom" />
            </div>
            <h1 className="text-white text-2xl mb-2">Iniciar Sesión</h1>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-4 w-full"
            >
              <input
                type="text"
                placeholder="Email o usuario"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="w-full p-2 bg-sidom-blue rounded-md border border-gray-700 focus:border-sidom-orange hover:border-sidom-orange text-white placeholder-sidom-light transition-all duration-200"
                required
              />
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 bg-sidom-blue rounded-md border border-gray-700 focus:border-blue-700 hover:border-sidom-orange text-white placeholder-sidom-light transition-all duration-200"
                required
              />
              <input
                type="submit"
                value="Iniciar sesión"
                className="w-full p-2 bg-gray-50 rounded-full font-bold text-sidom-dark border-4 border-gray-700 hover:border-sidom-orange transition-all duration-200 cursor-pointer"
              />
              {error && (
                <div className="text-red-400 text-center font-normal">
                  {error}
                </div>
              )}
            </form>
          </div>
        </section>
      </main>
    </>
  );
}
